var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12c0 5.5139 4.486 10 10 10 5.5139 0 10-4.4861 10-10 0-5.514-4.4861-10-10-10zm3.8462 10.7692h-3.077v3.077a.769.769 0 11-1.5384 0v-3.077h-3.077a.769.769 0 01-.5439-1.3131.769.769 0 01.544-.2253h3.0769v-3.077a.769.769 0 011.3131-.5439.769.769 0 01.2253.544v3.0769h3.077a.769.769 0 110 1.5384z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus-circle.4b244d2338b5d3e2937e5c745502c403.svg";